import React from 'react';

import { observer } from 'mobx-react';

import { Surface } from '@infoods/lifebase-ui';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import FolderSharedOutlinedIcon from '@mui/icons-material/FolderSharedOutlined';

import classes from './OverviewWidget.module.scss';
import { StatisticInfoCard } from '../../../../shared/components/StatisticInfoCard/StatisticInfoCard';
import { InfoCardTitle } from './InfoCardTitle/InfoCardTitle';
import { WidgetTitle } from '../WidgetTitle/WidgetTitle';
import { useOverviewData } from './hooks/useOverviewData';
import { entityDashboardFilterStore } from '../../../stores/entityDashboardFilterStore';
import { getComparisonPeriodForPreset } from '../../../../shared/utils/getComparisonPeriodForPreset/getComparisonPeriodForPreset';

const OverviewWidget = observer(() => {
  const { dateRangePreset, solutionTypeFilter } = entityDashboardFilterStore;

  const { overviewData } = useOverviewData({ dateRangePreset, solutionTypeFilter });

  const period = getComparisonPeriodForPreset(dateRangePreset);

  return (
    <Surface radius="l" className={classes.container}>
      <WidgetTitle
        title="Customer Overview"
        tooltipContent={
          <>
            New, active, total customers + scans
            <br />
            Excludes incomplete profiles
          </>
        }
      />
      {overviewData && (
        <div className={classes.infoContainer}>
          <StatisticInfoCard
            title={
              <InfoCardTitle title="New Customers" icon={<PersonAddAltOutlinedIcon />} />
            }
            value={overviewData.newCustomers.value}
            period={period}
          />
          <StatisticInfoCard
            title={
              <InfoCardTitle title="Active Customers" icon={<GroupsOutlinedIcon />} />
            }
            value={overviewData.activeCustomers.value}
            period={period}
            comparingPercentage={overviewData.activeCustomers.diffPercent}
          />
          <StatisticInfoCard
            title={
              <InfoCardTitle
                title="Scans This Period"
                icon={<DescriptionOutlinedIcon />}
              />
            }
            value={overviewData.newScans.value}
            period={period}
            comparingPercentage={overviewData.newScans.diffPercent}
          />
          <StatisticInfoCard
            title={
              <InfoCardTitle
                title="Total Customers"
                icon={<FolderSharedOutlinedIcon />}
              />
            }
            value={overviewData.totalCustomers}
          />
        </div>
      )}
    </Surface>
  );
});

export { OverviewWidget };
